export default __webpack_public_path__ + "static/whatsapp-e12f502957ca6ae7424ae6b77ec3538b.gif";